import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authoring.quality');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { formatKstDateTime, kstDateStartTimestamp, serviceTimestamp } from "src/libs/portal/season/time";

@Component({
    selector: 'wiz-page-authoring-quality',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authoring.quality/view.scss */
.quality-page {
  max-width: 1500px;
  margin: 0 auto;
  padding: 24px;
  color: #253a32;
}

button, input, select, textarea {
  font: inherit;
}

button {
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

button:focus-visible, a:focus-visible, input:focus-visible, select:focus-visible, textarea:focus-visible {
  outline: 3px solid rgba(20, 128, 91, 0.25);
  outline-offset: 2px;
}

.page-head {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: flex-start;
  margin-bottom: 18px;
}

.page-head p, .card > header span {
  margin: 0;
  color: #14805b;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.14em;
}

.page-head h1 {
  margin: 4px 0 5px;
  font-size: 26px;
  letter-spacing: -0.03em;
}

.page-head > div > span {
  color: #718079;
  font-size: 11px;
}

.page-head > button, .card > header > button {
  border: 1px solid #cedbd5;
  border-radius: 9px;
  padding: 9px 13px;
  background: #fff;
  color: #365047;
  font-size: 10px;
  font-weight: 750;
}

.quality-tabs {
  display: flex;
  gap: 4px;
  overflow-x: auto;
  margin-bottom: 18px;
  border-bottom: 1px solid #dfe8e4;
}

.quality-tabs button {
  flex: 0 0 auto;
  border: 0;
  border-bottom: 2px solid transparent;
  padding: 10px 13px;
  background: transparent;
  color: #6b7a74;
  font-size: 11px;
  font-weight: 750;
}

.quality-tabs button.active {
  border-color: #16805b;
  color: #126d4d;
}

.sub-tabs {
  display: flex;
  gap: 5px;
  margin-bottom: 10px;
}

.sub-tabs button {
  min-height: 32px;
  border: 1px solid #d5e1db;
  border-radius: 7px;
  padding: 0 11px;
  background: #fff;
  color: #5e7168;
  font-size: 11px;
  font-weight: 700;
}

.sub-tabs button.active {
  border-color: #b9dbc9;
  background: #eaf6f0;
  color: #176f50;
}

.keyboard-hint {
  margin: -13px 0 16px;
  color: #89958f;
  font-size: 8px;
  text-align: right;
}

.permission-notice, .permission-panel {
  display: flex;
  gap: 8px;
  align-items: center;
  border: 1px solid #d8e3de;
  border-radius: 10px;
  padding: 11px 13px;
  background: #f7faf9;
  color: #61726b;
  font-size: 10px;
}

.permission-notice {
  margin: -6px 0 16px;
}

.permission-notice strong, .permission-panel strong {
  color: #304a40;
}

.permission-panel {
  flex-direction: column;
  align-items: flex-start;
}

.permission-helper {
  margin-top: 10px;
  color: #778780;
  font-size: 9px;
}

.two-column.read-only-layout {
  grid-template-columns: minmax(0, 1fr);
}

.loading-state, .empty-state, .compact-empty {
  border: 1px dashed #cad9d2;
  border-radius: 13px;
  padding: 36px;
  background: #fff;
  color: #6f7f78;
  text-align: center;
}

.empty-state strong {
  color: #2b4038;
  font-size: 17px;
}

.empty-state p {
  margin: 7px 0 0;
}

.compact-empty {
  padding: 28px 16px;
  font-size: 11px;
}

.compact-empty.success {
  border-color: #bddfce;
  background: #f3fbf7;
  color: #267154;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 11px;
  margin-bottom: 14px;
}

.metric-grid article {
  border: 1px solid #dce6e1;
  border-radius: 13px;
  padding: 15px;
  background: #fff;
}

.metric-grid span {
  display: block;
  color: #77847f;
  font-size: 9px;
}

.metric-grid strong {
  display: inline-block;
  margin: 7px 5px 0 0;
  color: #183e30;
  font-size: 24px;
}

.metric-grid small {
  color: #8a9691;
  font-size: 9px;
}

.two-column {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px;
}

.narrow-panel {
  max-width: 920px;
}

.card {
  overflow: hidden;
  border: 1px solid #dce6e1;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 7px 22px rgba(25, 52, 42, 0.035);
}

.card > header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  padding: 15px 16px;
  border-bottom: 1px solid #e7eeeb;
}

.card > header h2 {
  margin: 3px 0 0;
  font-size: 16px;
}

.card > header em {
  color: #7b8883;
  font-size: 9px;
  font-style: normal;
}

.header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.header-actions button {
  border: 1px solid #cedbd5;
  border-radius: 7px;
  padding: 6px 8px;
  background: #fff;
  color: #365047;
  font-size: 8px;
}

.run-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto 70px;
  gap: 12px;
  align-items: center;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #edf2f0;
  padding: 13px 16px;
  background: #fff;
  color: inherit;
  text-align: left;
}

.run-row:hover, .run-row.selected {
  background: #f3faf7;
}

.run-row div, .version-row div, .session-main {
  min-width: 0;
}

.run-row strong, .version-row strong, .session-main strong {
  display: block;
  overflow: hidden;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.run-row small, .version-row small, .session-main small {
  display: block;
  margin-top: 3px;
  color: #87938e;
  font-size: 8px;
}

.run-row > span, .version-row > span, .status-pill {
  border-radius: 999px;
  padding: 4px 7px;
  background: #eef3f1;
  color: #60716a;
  font-size: 8px;
  font-weight: 750;
}

[data-status=PASS], [data-status=COMPLETED], [data-status=ACTIVE] {
  background: #e7f6ef !important;
  color: #1f7957 !important;
}

[data-status=REVIEW], [data-status=PAUSED], [data-status=SCHEDULED] {
  background: #fff2de !important;
  color: #96601e !important;
}

[data-status=FAILED], [data-status=CANCELED] {
  background: #fdecea !important;
  color: #a2473c !important;
}

.run-row b {
  color: #25483b;
  font-size: 11px;
  text-align: right;
}

.issue-row {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  padding: 13px 15px 13px 18px;
  border-bottom: 1px solid #edf2ef;
}

.issue-row::before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 3px;
  background: #e7a15f;
  content: "";
}

.issue-row[data-severity=BLOCKER]::before, .issue-row[data-severity=HIGH]::before {
  background: #d75b4c;
}

.issue-row[data-severity=LOW]::before {
  background: #95aaa1;
}

.issue-main span {
  color: #9a6640;
  font-size: 8px;
  font-weight: 800;
}

.issue-main strong {
  display: block;
  margin-top: 4px;
  font-size: 10px;
  line-height: 1.5;
}

.issue-main small {
  display: block;
  margin-top: 4px;
  color: #8b9692;
  font-size: 8px;
}

.issue-actions, .row-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
  align-items: center;
}

.issue-actions button, .issue-actions a, .row-actions button, .version-row button {
  border: 1px solid #d2ddd8;
  border-radius: 7px;
  padding: 6px 8px;
  background: #fff;
  color: #3c5a4f;
  font-size: 8px;
  text-decoration: none;
}

.scheduled-note {
  color: #8b6429;
  font-size: 8px;
  font-weight: 700;
}

.regression-alert {
  border-radius: 999px;
  padding: 5px 7px;
  background: #fdecea;
  color: #a2473c;
  font-size: 8px;
  font-weight: 800;
}

.resolved-mark {
  align-self: center;
  color: #3b795f;
  font-size: 8px;
}

.waiver-form {
  grid-column: 1/-1;
  display: flex;
  gap: 7px;
  align-items: flex-end;
  border-radius: 8px;
  padding: 9px;
  background: #fff8ed;
}

.waiver-form label {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  color: #765d3d;
  font-size: 8px;
}

.waiver-form input {
  height: 34px;
  border: 1px solid #e4cfad;
  border-radius: 7px;
  padding: 0 9px;
  background: #fff;
  font-size: 9px;
}

.waiver-form button, .artifact-action button {
  border: 1px solid #d2ddd8;
  border-radius: 7px;
  padding: 7px 9px;
  background: #fff;
  color: #3c5a4f;
  font-size: 8px;
}

.artifact-action {
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
  background: #f7faf9;
}

.form-card {
  padding-bottom: 15px;
}

.form-card > :not(header), .helper {
  margin-right: 16px;
  margin-left: 16px;
}

.field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 15px;
}

.field-grid.three {
  grid-template-columns: repeat(3, 1fr);
}

.field-grid .wide {
  grid-column: span 2;
}

.field-grid label, .full-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.field-grid label > span, .full-field > span {
  color: #52655d;
  font-size: 9px;
  font-weight: 750;
}

.field-grid input, .field-grid select, .full-field input, .full-field textarea, .compare-controls select {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #d2ddd8;
  border-radius: 8px;
  padding: 9px 10px;
  background: #fff;
  color: #2f443c;
  font-size: 10px;
}

.full-field {
  margin-top: 11px;
}

.full-field textarea {
  resize: vertical;
  font-family: inherit;
  line-height: 1.55;
}

.check-field {
  display: flex;
  gap: 7px;
  align-items: center;
  margin-top: 10px;
  color: #5f7069;
  font-size: 9px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 13px;
}

.form-actions button, .compare-controls button {
  border: 0;
  border-radius: 9px;
  padding: 10px 14px;
  background: #147b57;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
}

.version-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  gap: 10px;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #edf2ef;
}

.version-row span.good {
  background: #e7f6ef;
  color: #1f7957;
}

.version-row span.warn {
  background: #fff2de;
  color: #96601e;
}

.version-row span.bad {
  background: #fdecea;
  color: #a2473c;
}

.template-block {
  border-bottom: 1px solid #e8efec;
}

.template-block > header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 15px;
  background: #f8fbfa;
}

.template-block > header button {
  border: 0;
  padding: 0;
  background: transparent;
  color: #176f50;
  font-size: 11px;
  font-weight: 800;
}

.template-block > header small {
  color: #82908a;
  font-size: 8px;
}

.compare-card, .session-card, .detail-card {
  margin-top: 14px;
}

.evaluation-dashboard {
  margin-top: 14px;
}

.compact-metrics {
  margin: 15px;
}

.dimension-comparison {
  overflow-x: auto;
  border-top: 1px solid #edf2ef;
}

.dimension-comparison article {
  display: grid;
  grid-template-columns: minmax(180px, 1.2fr) 150px repeat(7, minmax(64px, 0.55fr));
  gap: 8px;
  align-items: center;
  min-width: 850px;
  padding: 10px 15px;
  border-bottom: 1px solid #edf2ef;
}

.comparison-name strong, .comparison-name small {
  display: block;
}

.comparison-name strong {
  font-size: 10px;
}

.comparison-name small {
  margin-top: 3px;
  color: #87938e;
  font-size: 8px;
}

.overall-bar {
  position: relative;
  overflow: hidden;
  height: 22px;
  border-radius: 7px;
  background: #e9f0ed;
}

.overall-bar span {
  display: block;
  height: 100%;
  background: #53a986;
}

.overall-bar b {
  position: absolute;
  top: 4px;
  right: 7px;
  color: #173d2f;
  font-size: 9px;
}

.dimension-cell {
  border-radius: 7px;
  padding: 5px 6px;
  background: #f4f8f6;
  text-align: center;
}

.dimension-cell span, .dimension-cell strong {
  display: block;
}

.dimension-cell span {
  overflow: hidden;
  color: #78857f;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dimension-cell strong {
  margin-top: 2px;
  color: #285344;
  font-size: 10px;
}

.compare-controls {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto;
  gap: 10px;
  align-items: center;
  padding: 15px;
}

.compare-controls > span {
  color: #82908a;
  font-size: 9px;
}

.comparison-result {
  display: grid;
  grid-template-columns: 1fr 0.7fr 1fr;
  gap: 10px;
  padding: 0 15px 15px;
}

.comparison-result article {
  border: 1px solid #dce6e1;
  border-radius: 10px;
  padding: 12px;
  text-align: center;
}

.comparison-result article.recommend {
  border-color: #9bcdb7;
  background: #f0faf6;
}

.comparison-result span, .comparison-result small {
  display: block;
  color: #7c8984;
  font-size: 8px;
}

.comparison-result strong {
  display: block;
  margin: 6px 0;
  font-size: 19px;
}

.helper {
  margin-top: 14px;
  color: #687871;
  font-size: 10px;
  line-height: 1.7;
}

.session-row {
  display: grid;
  grid-template-columns: minmax(180px, 1.3fr) minmax(100px, 0.6fr) 75px auto minmax(190px, auto);
  gap: 12px;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #edf2ef;
}

.history-filters {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 0.7fr;
  gap: 8px;
  padding: 12px 15px;
  background: #f8fbfa;
}

.history-filters label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #607169;
  font-size: 8px;
}

.history-filters input, .history-filters select {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #d2ddd8;
  border-radius: 7px;
  padding: 7px 8px;
  background: #fff;
  color: #30473e;
  font-size: 9px;
}

.progress {
  overflow: hidden;
  height: 6px;
  border-radius: 999px;
  background: #e9efec;
}

.progress span {
  display: block;
  height: 100%;
  background: #278762;
}

.session-score {
  text-align: right;
}

.session-score strong {
  display: block;
  font-size: 14px;
}

.session-score small {
  color: #83908b;
  font-size: 8px;
}

.evaluation-table {
  padding: 10px 15px 15px;
}

.table-head, .table-row {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) 60px 60px 90px 70px;
  gap: 10px;
  padding: 9px;
  border-bottom: 1px solid #edf2ef;
  font-size: 9px;
}

.table-head {
  color: #78857f;
  font-weight: 750;
}

.table-row strong {
  color: #176f50;
}

@media (max-width: 1050px) {
  .two-column, .metric-grid {
    grid-template-columns: 1fr 1fr;
  }
  .form-layout {
    grid-template-columns: 1fr;
  }
  .session-row {
    grid-template-columns: minmax(0, 1fr) 120px auto;
  }
  .session-row .progress, .session-row .row-actions {
    grid-column: span 3;
  }
  .history-filters {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 700px) {
  .quality-page {
    padding: 16px;
  }
  .quality-tabs {
    scroll-snap-type: x proximity;
    scrollbar-width: thin;
  }
  .quality-tabs button {
    scroll-snap-align: start;
  }
  .keyboard-hint {
    text-align: left;
  }
  .page-head {
    flex-direction: column;
  }
  .metric-grid, .two-column, .field-grid, .field-grid.three {
    grid-template-columns: 1fr;
  }
  .field-grid .wide {
    grid-column: auto;
  }
  .compare-controls, .comparison-result {
    grid-template-columns: 1fr;
  }
  .compare-controls > span {
    text-align: center;
  }
  .issue-row, .run-row, .session-row {
    grid-template-columns: 1fr;
  }
  .issue-actions, .row-actions {
    justify-content: flex-start;
  }
  .session-row .progress, .session-row .row-actions {
    grid-column: auto;
  }
  .session-score {
    text-align: left;
  }
  .evaluation-table {
    overflow-x: auto;
  }
  .history-filters {
    grid-template-columns: 1fr;
  }
  .table-head, .table-row {
    min-width: 540px;
  }
}
/* Drive UI surface and readable control density */
.quality-page {
  max-width: 1540px;
  min-height: 620px;
  box-sizing: border-box;
  margin: 24px auto 36px;
  padding: 0 22px 22px;
  border: 1px solid #dfe6e3;
  border-radius: 16px;
  color: #22312c;
  background: #fff;
  box-shadow: 0 1px 2px rgba(30, 50, 43, 0.03);
}

.page-head {
  min-height: 70px;
  align-items: center;
  margin: 0 -22px;
  padding: 0 22px;
  border-bottom: 1px solid #e7ecea;
}

.page-head p {
  color: #18845f;
  font-size: 11px;
  letter-spacing: 0.04em;
}

.page-head h1 {
  margin: 3px 0;
  color: #172f27;
  font-size: 20px;
}

.page-head span {
  font-size: 12px;
}

.page-head > button {
  min-height: 36px;
  padding: 0 13px;
  font-size: 11px;
}

.quality-tabs {
  margin: 0 -22px;
  padding: 10px 22px;
  border-bottom: 1px solid #edf1ef;
  border-radius: 0;
  background: #fbfcfc;
}

.quality-tabs button {
  min-height: 32px;
  font-size: 12px;
}

.keyboard-hint, .permission-notice, .loading-state {
  font-size: 11px;
}

.tab-panel {
  margin-top: 16px;
}

.metric-grid article span, .metric-grid article small {
  font-size: 11px;
}

.card {
  border-radius: 11px;
  box-shadow: none;
}

.card > header span, .template-block > header small, .comparison-name small, .dimension-cell span, .comparison-result span, .comparison-result small, .session-score small, .history-filters label {
  font-size: 10px;
}

.card > header h2 {
  font-size: 14px;
}

.card > header button, .artifact-action button, .row-actions button, .row-actions a, .issue-actions button, .issue-actions a {
  min-height: 30px;
  font-size: 11px;
}

.run-row, .issue-row, .session-row, .version-row {
  font-size: 11px;
}

.field-grid label > span, .full-field > span, .check-field, .permission-helper, .helper {
  font-size: 11px;
}

.field-grid input, .field-grid select, .full-field textarea, .history-filters input, .history-filters select {
  font-size: 12px;
}

.table-head, .table-row {
  font-size: 11px;
}

@media (max-width: 700px) {
  .quality-page {
    margin: 14px;
    padding: 0 16px 18px;
  }
  .page-head {
    margin: 0 -16px;
    padding: 14px 16px;
  }
  .quality-tabs {
    margin: 0 -16px;
    padding: 9px 16px;
  }
}`],
})
export class PageAuthoringQualityComponent implements OnInit {
    public loading: boolean = true;
    public busy: string = '';
    public tab: string = 'overview';
    public standardsMode: string = 'terminology';
    public validationMode: string = 'golden';
    public showEvaluationSetup: boolean = false;
    public qualityEditable: boolean = false;
    public qualityAdmin: boolean = false;
    public evaluationEditable: boolean = false;
    public terminologyVersions: any[] = [];
    public templates: any[] = [];
    public runs: any[] = [];
    public issues: any[] = [];
    public selectedRun: any = null;
    public targets: any[] = [];
    public sessions: any[] = [];
    public datasetVersions: any[] = [];
    public selectedSession: any = null;
    public evaluationItems: any[] = [];
    public comparison: any = null;
    public evaluationFilter: any = { query: '', status: '', from: '', minimum_score: '' };
    public waivingIssueId: string = '';
    public waiverNote: string = '';
    public form: any = this.newForms();

    public tabs: any[] = [
        { id: 'overview', label: '현황', shortcut: 'Alt+1' },
        { id: 'standards', label: '기준 관리', shortcut: 'Alt+2' },
        { id: 'validation', label: '검증', shortcut: 'Alt+3' },
        { id: 'evaluation', label: '모델 평가', shortcut: 'Alt+4' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public currentDataset() {
        return this.service.auth.session.current_dataset || {};
    }

    private key(prefix: string) {
        let cryptoApi: any = typeof window !== 'undefined' ? (window as any).crypto : null;
        let tail = cryptoApi && cryptoApi.randomUUID
            ? cryptoApi.randomUUID()
            : Date.now().toString(36) + '-' + Math.random().toString(36).substring(2, 10);
        return prefix + ':' + tail;
    }

    private newForms() {
        return {
            terminology: {
                version: 'v1.0',
                note: '',
                activate: true,
                entries: '[]',
                request_id: this.key('terminology')
            },
            instruction: {
                template_id: '',
                name: '',
                domain_code: 'KOREAN_MEDICINE',
                scenario_code: 'KNOWLEDGE_QA',
                audience_code: 'PROFESSIONAL',
                variables: 'evidence, topic',
                instruction_text: '',
                change_note: '',
                request_id: this.key('instruction')
            },
            compare: { left_id: '', right_id: '' },
            regression: { current_version_id: '', baseline_version_id: '', request_id: this.key('regression') },
            target: {
                name: '',
                target_type: 'STORED_GOLDEN',
                model_version: 'golden-baseline-v1',
                endpoint_ref: '',
                config: '{}',
                request_id: this.key('evaluation-target')
            },
            session: {
                target_id: '',
                dataset_version_id: '',
                baseline_session_id: '',
                name: '',
                repeat_count: 3,
                scheduled_for: '',
                schedule_interval_minutes: 0,
                responses: '[]',
                request_id: this.key('evaluation-session')
            },
            fusion: {
                manifest: '',
                request_id: this.key('fusion')
            }
        };
    }

    private async error(message: string) {
        await this.service.modal.show({
            title: '요청을 완료하지 못했습니다',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    private message(result: any, fallback: string) {
        return result && result.data && result.data.message ? result.data.message : fallback;
    }

    public async selectTab(tab: string) {
        this.tab = tab;
        await this.service.render();
    }

    public async selectStandards(mode: string) {
        this.standardsMode = mode;
        await this.service.render();
    }

    public async selectValidation(mode: string) {
        this.validationMode = mode;
        await this.service.render();
    }

    public async toggleEvaluationSetup() {
        this.showEvaluationSetup = !this.showEvaluationSetup;
        await this.service.render();
    }

    @HostListener('document:keydown', ['$event'])
    public async onShortcut(event: KeyboardEvent) {
        if (!event.altKey || event.ctrlKey || event.metaKey) return;
        let index = Number(event.key) - 1;
        if (!Number.isInteger(index) || index < 0 || index >= this.tabs.length) return;
        event.preventDefault();
        await this.selectTab(this.tabs[index].id);
    }

    public async load() {
        let datasetId = this.currentDataset().dataset_id;
        if (!datasetId) {
            this.loading = false;
            await this.service.render();
            return;
        }
        this.loading = true;
        await this.service.render();
        try {
            let results: any[] = await Promise.all([
                this.service.request.post('/api/quality/overview', { dataset_id: datasetId }),
                this.service.request.post('/api/quality/evaluations/prepare', { dataset_id: datasetId })
            ]);
            if (results[0].code !== 200) {
                await this.error(this.message(results[0], '품질 현황을 불러오지 못했습니다.'));
                return;
            }
            if (results[1].code !== 200) {
                await this.error(this.message(results[1], '평가 현황을 불러오지 못했습니다.'));
                return;
            }
            let quality = results[0].data || {};
            let evaluation = results[1].data || {};
            let qualityPermissions = quality.permissions || {};
            this.qualityEditable = qualityPermissions.can_edit !== undefined
                ? !!qualityPermissions.can_edit : !!quality.can_edit;
            this.qualityAdmin = !!qualityPermissions.can_administer;
            this.evaluationEditable = !!evaluation.can_edit;
            if (!this.qualityAdmin) this.form.terminology.activate = false;
            this.terminologyVersions = quality.terminology_versions || [];
            this.templates = quality.templates || [];
            this.runs = quality.runs || [];
            this.issues = quality.latest_issues || [];
            this.selectedRun = this.runs.length ? this.runs[0] : null;
            this.targets = evaluation.targets || [];
            this.sessions = evaluation.sessions || [];
            this.datasetVersions = evaluation.dataset_versions || [];
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async saveTerminology() {
        if (this.busy) return;
        this.busy = 'terminology';
        await this.service.render();
        try {
            let value = JSON.parse(this.form.terminology.entries);
            let result: any = await this.service.request.post('/api/quality/terminology/save', {
                dataset_id: this.currentDataset().dataset_id,
                version: this.form.terminology.version,
                note: this.form.terminology.note,
                activate: this.form.terminology.activate,
                entries: JSON.stringify(value),
                request_id: this.form.terminology.request_id
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.error(this.message(result, '표준용어 사전을 저장하지 못했습니다.'));
                return;
            }
            this.form.terminology.request_id = this.key('terminology');
            await this.load();
        } catch (error) {
            await this.error(error && error.message ? error.message : '표준용어 JSON을 확인해 주세요.');
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async activateTerminology(item: any) {
        if (this.busy || item.status === 'ACTIVE') return;
        this.busy = 'term-' + item.id;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/quality/terminology/activate', {
                dataset_id: this.currentDataset().dataset_id,
                terminology_id: item.id
            });
            if (result.code !== 200) {
                await this.error(this.message(result, '사전 버전을 활성화하지 못했습니다.'));
                return;
            }
            await this.load();
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async scanTextUnits() {
        if (this.busy) return;
        this.busy = 'scan';
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/quality/text-units/scan', {
                dataset_id: this.currentDataset().dataset_id,
                request_id: this.key('text-unit-scan')
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.error(this.message(result, 'TextUnit 품질 검사를 실행하지 못했습니다.'));
                return;
            }
            await this.load();
            await this.selectTab('overview');
            await this.openRun(result.data.run);
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async openRun(run: any) {
        this.selectedRun = run;
        let result: any = await this.service.request.post('/api/quality/issues/list', {
            dataset_id: this.currentDataset().dataset_id,
            run_id: run.id,
            limit: 300
        });
        if (result.code !== 200) {
            await this.error(this.message(result, '품질 이슈를 불러오지 못했습니다.'));
            return;
        }
        this.issues = result.data.issues || [];
        await this.service.render();
    }

    public async resolveIssue(issue: any, resolution: string) {
        if (this.busy || issue.status !== 'OPEN') return;
        let note = resolution === 'WAIVED' ? String(this.waiverNote || '').trim() : '';
        if (resolution === 'WAIVED' && !note) {
            await this.error('예외 승인 근거를 입력해 주세요.');
            return;
        }
        this.busy = 'issue-' + issue.id;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/quality/issues/resolve', {
                dataset_id: this.currentDataset().dataset_id,
                issue_id: issue.id,
                resolution: resolution,
                note: note || ''
            });
            if (result.code !== 200) {
                await this.error(this.message(result, '이슈를 해소하지 못했습니다.'));
                return;
            }
            issue.status = 'RESOLVED';
            issue.resolution = result.data.issue.resolution;
            this.waivingIssueId = '';
            this.waiverNote = '';
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async beginWaiver(issue: any) {
        this.waivingIssueId = issue.id;
        this.waiverNote = '';
        await this.service.render();
    }

    public async cancelWaiver() {
        this.waivingIssueId = '';
        this.waiverNote = '';
        await this.service.render();
    }

    public async downloadRunArtifact(run: any) {
        let result: any = await this.service.request.post('/api/quality/runs/detail', {
            dataset_id: this.currentDataset().dataset_id,
            run_id: run.id
        });
        if (result.code !== 200) {
            await this.error(this.message(result, '품질 산출물을 불러오지 못했습니다.'));
            return;
        }
        let blob = new Blob(
            [JSON.stringify(result.data.run.artifact || {}, null, 2)],
            { type: 'application/json;charset=utf-8' }
        );
        let anchor = document.createElement('a');
        anchor.href = URL.createObjectURL(blob);
        anchor.download = 'quality-' + run.run_type.toLowerCase() + '-' + run.id.substring(0, 8) + '.json';
        anchor.click();
        setTimeout(() => URL.revokeObjectURL(anchor.href), 1000);
    }

    public async openQualityReport(run: any) {
        let result: any = await this.service.request.post('/api/quality/runs/detail', {
            dataset_id: this.currentDataset().dataset_id,
            run_id: run.id
        });
        if (result.code !== 200) {
            await this.error(this.message(result, '품질 보고서를 생성하지 못했습니다.'));
            return;
        }
        let blob = new Blob([result.data.report_html], { type: 'text/html;charset=utf-8' });
        let url = URL.createObjectURL(blob);
        window.open(url, '_blank', 'noopener');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
    }

    public editTemplate(template: any) {
        let latest = template.versions && template.versions.length ? template.versions[0] : null;
        this.form.instruction.template_id = template.id;
        this.form.instruction.name = template.name;
        this.form.instruction.domain_code = template.domain_code;
        this.form.instruction.scenario_code = template.scenario_code;
        this.form.instruction.audience_code = template.audience_code;
        if (latest) {
            this.form.instruction.variables = (latest.variables || []).join(', ');
            this.form.instruction.instruction_text = latest.instruction_text;
        }
        this.form.instruction.change_note = '';
        this.form.instruction.request_id = this.key('instruction-version');
    }

    public clearTemplate() {
        this.form.instruction.template_id = '';
        this.form.instruction.name = '';
        this.form.instruction.change_note = '';
        this.form.instruction.request_id = this.key('instruction');
    }

    public instructionVersions() {
        let values: any[] = [];
        this.templates.forEach((template: any) => {
            (template.versions || []).forEach((version: any) => values.push({
                id: version.id,
                label: template.name + ' v' + version.version_no + ' · ' + (version.quality.score || 0) + '점'
            }));
        });
        return values;
    }

    public async saveInstruction() {
        if (this.busy) return;
        this.busy = 'instruction';
        await this.service.render();
        try {
            let values = String(this.form.instruction.variables || '').split(',').map((value: string) => value.trim()).filter(Boolean);
            let result: any = await this.service.request.post('/api/quality/instructions/save', {
                dataset_id: this.currentDataset().dataset_id,
                template_id: this.form.instruction.template_id,
                name: this.form.instruction.name,
                domain_code: this.form.instruction.domain_code,
                scenario_code: this.form.instruction.scenario_code,
                audience_code: this.form.instruction.audience_code,
                variables: JSON.stringify(values),
                instruction_text: this.form.instruction.instruction_text,
                change_note: this.form.instruction.change_note,
                request_id: this.form.instruction.request_id
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.error(this.message(result, 'Instruction 버전을 저장하지 못했습니다.'));
                return;
            }
            this.form.instruction.template_id = result.data.template.id;
            this.form.instruction.request_id = this.key('instruction-version');
            await this.load();
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async compareInstructions() {
        if (!this.form.compare.left_id || !this.form.compare.right_id) {
            await this.error('비교할 두 Instruction 버전을 선택해 주세요.');
            return;
        }
        let result: any = await this.service.request.post('/api/quality/instructions/compare', {
            dataset_id: this.currentDataset().dataset_id,
            left_id: this.form.compare.left_id,
            right_id: this.form.compare.right_id
        });
        if (result.code !== 200) {
            await this.error(this.message(result, 'Instruction을 비교하지 못했습니다.'));
            return;
        }
        this.comparison = result.data;
        await this.service.render();
    }

    public async activateInstruction(template: any, version: any) {
        if (this.busy || template.active_version_no === version.version_no) return;
        this.busy = 'instruction-active';
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/quality/instructions/activate', {
                dataset_id: this.currentDataset().dataset_id,
                template_id: template.id,
                version_no: version.version_no
            });
            if (result.code !== 200) {
                await this.error(this.message(result, 'Instruction 버전을 활성화하지 못했습니다.'));
                return;
            }
            await this.load();
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async runRegression() {
        if (this.busy) return;
        this.busy = 'regression';
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/quality/golden/regression', {
                dataset_id: this.currentDataset().dataset_id,
                current_version_id: this.form.regression.current_version_id,
                baseline_version_id: this.form.regression.baseline_version_id,
                request_id: this.form.regression.request_id
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.error(this.message(result, 'Golden 회귀 검사를 실행하지 못했습니다.'));
                return;
            }
            this.form.regression.request_id = this.key('regression');
            await this.load();
            await this.selectTab('overview');
            await this.openRun(result.data.run);
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async saveTarget() {
        if (this.busy) return;
        this.busy = 'target';
        await this.service.render();
        try {
            JSON.parse(this.form.target.config || '{}');
            let result: any = await this.service.request.post('/api/quality/evaluations/targets/save', {
                dataset_id: this.currentDataset().dataset_id,
                name: this.form.target.name,
                target_type: this.form.target.target_type,
                model_version: this.form.target.model_version,
                endpoint_ref: this.form.target.endpoint_ref,
                config: this.form.target.config,
                request_id: this.form.target.request_id
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.error(this.message(result, '평가 대상을 저장하지 못했습니다.'));
                return;
            }
            this.form.target.request_id = this.key('evaluation-target');
            await this.load();
        } catch (error) {
            await this.error(error && error.message ? error.message : '평가 대상 설정을 확인해 주세요.');
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async createSession() {
        if (this.busy) return;
        this.busy = 'session';
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/quality/evaluations/sessions/create', {
                dataset_id: this.currentDataset().dataset_id,
                target_id: this.form.session.target_id,
                dataset_version_id: this.form.session.dataset_version_id,
                baseline_session_id: this.form.session.baseline_session_id,
                name: this.form.session.name,
                repeat_count: this.form.session.repeat_count,
                scheduled_for: this.form.session.scheduled_for,
                schedule_interval_minutes: this.form.session.schedule_interval_minutes,
                request_id: this.form.session.request_id
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.error(this.message(result, '평가 세션을 만들지 못했습니다.'));
                return;
            }
            this.form.session.request_id = this.key('evaluation-session');
            await this.load();
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async controlSession(session: any, action: string) {
        if (this.busy) return;
        this.busy = 'session-' + session.id;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/quality/evaluations/sessions/control', {
                dataset_id: this.currentDataset().dataset_id,
                session_id: session.id,
                action: action
            });
            if (result.code !== 200) {
                await this.error(this.message(result, '평가 세션 상태를 변경하지 못했습니다.'));
                return;
            }
            await this.load();
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async processSession(session: any) {
        if (this.busy) return;
        this.busy = 'process-' + session.id;
        await this.service.render();
        try {
            let target = this.targets.find((item: any) => item.id === session.target_id);
            let responses = '[]';
            if (target && target.target_type === 'EXTERNAL_RESPONSE') {
                try {
                    JSON.parse(this.form.session.responses || '[]');
                    responses = this.form.session.responses || '[]';
                } catch (error) {
                    await this.error('외부 응답 JSON 형식을 확인해 주세요.');
                    return;
                }
            }
            let result: any = await this.service.request.post('/api/quality/evaluations/sessions/process', {
                dataset_id: this.currentDataset().dataset_id,
                session_id: session.id,
                responses: responses,
                chunk_size: 100
            });
            if (result.code !== 200) {
                await this.error(this.message(result, '평가 묶음을 처리하지 못했습니다.'));
                return;
            }
            await this.load();
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async runDueSessions() {
        if (this.busy) return;
        this.busy = 'scheduler';
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/quality/evaluations/scheduler/run-due', {
                dataset_id: this.currentDataset().dataset_id,
                limit: 10
            });
            if (result.code !== 200) {
                await this.error(this.message(result, '예약 평가를 처리하지 못했습니다.'));
                return;
            }
            await this.load();
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public async sessionDetail(session: any) {
        let result: any = await this.service.request.post('/api/quality/evaluations/sessions/detail', {
            dataset_id: this.currentDataset().dataset_id,
            session_id: session.id,
            limit: 500
        });
        if (result.code !== 200) {
            await this.error(this.message(result, '평가 상세를 불러오지 못했습니다.'));
            return;
        }
        this.selectedSession = result.data.session;
        this.evaluationItems = result.data.items || [];
        await this.service.render();
    }

    public async openReport(session: any, format: string) {
        let result: any = await this.service.request.post('/api/quality/evaluations/reports/create', {
            dataset_id: this.currentDataset().dataset_id,
            session_id: session.id,
            format: format
        });
        if (result.code !== 200) {
            await this.error(this.message(result, '평가 보고서를 생성하지 못했습니다.'));
            return;
        }
        let binary = atob(result.data.content_base64);
        let bytes = new Uint8Array(binary.length);
        for (let index = 0; index < binary.length; index++) bytes[index] = binary.charCodeAt(index);
        let blob = new Blob([bytes], { type: result.data.mime_type });
        let url = URL.createObjectURL(blob);
        window.open(url, '_blank', 'noopener');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
    }

    public async runFusion() {
        if (this.busy) return;
        this.busy = 'fusion';
        await this.service.render();
        try {
            JSON.parse(this.form.fusion.manifest);
            let result: any = await this.service.request.post('/api/quality/fusion/run', {
                dataset_id: this.currentDataset().dataset_id,
                manifest: this.form.fusion.manifest,
                request_id: this.form.fusion.request_id
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.error(this.message(result, '공공 의료데이터를 정규화하지 못했습니다.'));
                return;
            }
            this.form.fusion.request_id = this.key('fusion');
            await this.load();
            await this.selectTab('overview');
        } catch (error) {
            await this.error(error && error.message ? error.message : 'manifest JSON을 확인해 주세요.');
        } finally {
            this.busy = '';
            await this.service.render();
        }
    }

    public runTypeLabel(value: string) {
        let labels: any = {
            TEXT_UNIT_SCAN: '원문 품질',
            GOLDEN_REGRESSION: 'Golden 회귀',
            PUBLIC_DATA_FUSION: '공공데이터 융합'
        };
        return labels[value] || value;
    }

    public statusLabel(value: string) {
        let labels: any = {
            ACTIVE: '사용 중', DRAFT: '초안', ARCHIVED: '보관', COMPLETED: '완료',
            READY: '실행 대기', SCHEDULED: '예약', RUNNING: '실행 중', PAUSED: '일시정지',
            FAILED: '실패', CANCELED: '취소', PASS: '통과', REVIEW: '검토 필요', RESOLVED: '해소', OPEN: '미해소'
        };
        return labels[value] || value || '-';
    }

    public canStartSession(session: any) {
        if (!session || session.status === 'READY') return true;
        if (session.status !== 'SCHEDULED' || !session.scheduled_for) return false;
        let scheduled = serviceTimestamp(session.scheduled_for);
        return isNaN(scheduled) || scheduled <= Date.now();
    }

    public isWaitingForSchedule(session: any) {
        return !!session && session.status === 'SCHEDULED' && !this.canStartSession(session);
    }

    public completedSessions() {
        return this.sessions.filter((session: any) => session.status === 'COMPLETED').slice(0, 6);
    }

    public latestCompleted() {
        let values = this.completedSessions();
        return values.length ? values[0] : null;
    }

    public regressionAlertCount() {
        return this.sessions.filter((session: any) => !!(session.metrics || {}).regression_alert).length;
    }

    public filteredSessions() {
        let query = String(this.evaluationFilter.query || '').trim().toLowerCase();
        let status = String(this.evaluationFilter.status || '');
        let minimum = this.evaluationFilter.minimum_score === ''
            ? null : Number(this.evaluationFilter.minimum_score);
        let from = this.evaluationFilter.from
            ? kstDateStartTimestamp(this.evaluationFilter.from) : NaN;
        return this.sessions.filter((session: any) => {
            let haystack = [session.name, session.target_name, session.model_version].join(' ').toLowerCase();
            let created = serviceTimestamp(session.created_at);
            return (!query || haystack.includes(query))
                && (!status || session.status === status)
                && (minimum === null || Number((session.metrics || {}).average_score || 0) >= minimum)
                && (isNaN(from) || isNaN(created) || created >= from);
        });
    }

    public dimensionEntries(session: any) {
        let scores = (session && session.metrics && session.metrics.dimension_scores) || {};
        return Object.keys(scores).sort().map((name: string) => ({ name: name, score: Number(scores[name] || 0) }));
    }

    public dimensionLabel(value: string) {
        let labels: any = {
            accuracy: '정확도', relevance: '관련성', groundedness: '근거성', safety: '안전성',
            consistency: '일관성', clarity: '명확성', answerability: '답변가능성'
        };
        return labels[value] || value;
    }

    public estimatedCompletion(session: any) {
        if (!session) return '-';
        if (session.status === 'COMPLETED') return '완료';
        if (this.isWaitingForSchedule(session)) return this.formatDate(session.scheduled_for) + ' 시작';
        let remaining = Math.max(0, Number(session.total_count || 0) - Number(session.current_index || 0));
        let average = Number((session.metrics || {}).average_duration_ms || 0);
        if (!average) return '남은 ' + remaining + '건';
        let seconds = Math.ceil(remaining * average / 1000);
        return '약 ' + (seconds < 60 ? seconds + '초' : Math.ceil(seconds / 60) + '분') + ' 남음';
    }

    public scoreClass(value: any) {
        let score = Number(value || 0);
        return score >= 80 ? 'good' : score >= 60 ? 'warn' : 'bad';
    }

    public formatDate(value: string) {
        return formatKstDateTime(value, '-');
    }
}

export default PageAuthoringQualityComponent;